import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=238d4025&scoped=true&"
import script from "./AuthPage.vue?vue&type=script&lang=js&"
export * from "./AuthPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthPage.vue?vue&type=style&index=0&id=238d4025&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d4025",
  null
  
)

export default component.exports